import { formatDateTime } from './date-time-util.js';
import { C as CORE_DATA_TYPE } from '../core-data-type.enum-a3958165.js';
import 'luxon';

var formatDataByField = function formatDataByField(formDefinition, data) {
  var dataType = formDefinition.dataType,
      metadata = formDefinition.metadata;

  switch (dataType) {
    case CORE_DATA_TYPE.DATE:
      return formatDateTime(data, 'yyyy-MM-dd');

    case CORE_DATA_TYPE.DATE_TIME:
      return formatDateTime(data, 'yyyy-MM-dd HH:mm');

    case CORE_DATA_TYPE.TIME:
      return formatDateTime(data, 'HH:mm');

    case CORE_DATA_TYPE.USER:
      return data === null || data === void 0 ? void 0 : data.name;

    case CORE_DATA_TYPE.SELECT:
      return (((metadata === null || metadata === void 0 ? void 0 : metadata.options) || []).find(function (option) {
        return option.value === data;
      }) || {
        label: data
      }).label;

    case CORE_DATA_TYPE.SWITCH:
      return data ? (metadata === null || metadata === void 0 ? void 0 : metadata.trueLabel) || 'True' : (metadata === null || metadata === void 0 ? void 0 : metadata.falseLabel) || 'False';

    default:
      return Array.isArray(data) ? data.join(',') : data;
  }
};

export { formatDataByField };
